import { AliasService } from './../../alias/alias.service';
import { SnapshotService } from './../../snapshot/snapshot.service';
import { hyphenatedMonthDay } from '@liquitics/transaction';
import { GetSurvivalHorizonServiceDataOutput, } from '@liquitics/transaction';
import { AppConfig } from './../../app.config';
import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { SurvivalHorizonService } from './../survival-horizon.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';

@Component({
    selector: 'app-significant-ladder',
    templateUrl: './significant-ladder.component.html',
    styleUrls: ['./significant-ladder.component.css']
})
export class SignificantLadderComponent implements OnInit, OnDestroy {
    @Input()
    title: string;
    @Input()
    type: string;

    initialized = false;
    significantAttribute;

    tableData: any = [];
    headerDates: string[] = [];
    dates: string[] = [];
    private dataStreamDisposable: Subscription;
    subscription: Subscription;

    currentFirstShownRowIndex = 0;

    constructor(private survivalHorizonService: SurvivalHorizonService,
        private dashboardEventService: DashboardEventService,
        private snapshotService: SnapshotService,
        private aliasService: AliasService,
        private appConfig: AppConfig) {
    }

    ngOnInit() {
        const m = this.appConfig.getTodayStartUTC().clone();
        for (let i = 0; i < 5; i++) {
            this.headerDates.push(hyphenatedMonthDay(m));
            this.dates.push(m.format('YYYY-MM-DD'));
            m.add(1, 'days');
        }
        this.dataStreamDisposable = this.survivalHorizonService.getPollingDataSubject()
            .subscribe({
                next: (data: GetSurvivalHorizonServiceDataOutput) => {
                    this.updateTableData(data);
                }, error: (err) => {
                    console.log(err);
                    throw err;
                }
            });
        if (this.type === 'EXTERNAL') {
            this.significantAttribute = 'clientGroup';
        } else if (this.type === 'INTERNAL') {
            this.significantAttribute = 'desk';
        } else {
            this.significantAttribute = 'desk';
        }
        this.subscription = (this.dashboardEventService.currencySelectionSubject.subscribe({
            next: currency => {
                this.initialized = false;
                const currentRequest = this.survivalHorizonService.buildPollingRequestParams();
                this.survivalHorizonService.getDataObservable(currentRequest)
                    .pipe(take(1))
                    .toPromise()
                    .then((data: GetSurvivalHorizonServiceDataOutput) => {
                        this.updateTableData(data);
                    })
            }
        }));
    }

    onPage(event) {
        this.currentFirstShownRowIndex = event.first;
    }

    private updateTableData(data: GetSurvivalHorizonServiceDataOutput) {
        let forecasts;
        if (this.type === 'EXTERNAL') {
            forecasts = data
                .clientForecasts
                .map((clientForecast) => {
                    clientForecast.clientGroup = this.aliasService.clientAlias(clientForecast.clientGroup);
                    return clientForecast;
                })
                ;
        } else if (this.type === 'INTERNAL') {
            if (data.deskForecasts) {
                forecasts = data.deskForecasts
                    .map((position: any) => {
                        const deskForecast = {
                            desk: position.desk,
                            amount: position.inAmount + position.outAmount,
                            date: position.bucket,
                            currency: position.currency,
                        }
                        return deskForecast;
                    })
            }
        } else if (this.type === 'ENTITY') {
            if (data.deskForecasts) {
                const entityMap = this.snapshotService.applicationConfiguration.deskToOrganization;
                forecasts = data.deskForecasts
                    .map((position: any) => {
                        const deskForecast = {
                            desk: entityMap[position.desk],
                            entity: entityMap[position.desk],
                            amount: position.inAmount + position.outAmount,
                            date: position.bucket,
                            currency: position.currency,
                        }
                        return deskForecast;
                    })
                const byEntity = forecasts.reduce((grouped, d) => {
                    const key = d.entity + d.date;
                    grouped[key] = grouped[key] || [];
                    grouped[key].push(d);
                    return grouped;
                }, {});
                forecasts = Object.keys(byEntity)
                    .map((entity: string) => {
                        return byEntity[entity].reduce((prev, curr) => {
                            prev.desk = prev.entity;
                            prev.amount += curr.amount;
                            return prev;
                        })
                    });
            }
        }
        if (forecasts) {
            const groupedBySignificantMember = forecasts
                .map((f: any) => {
                    this.dates.forEach((d: string, index: number) => {
                        let amount = 0.0;
                        if (d === f.date) {
                            amount = f.amount;
                        }
                        f['day' + (index + 1) + 'Amount'] = amount;
                    })
                    return f;
                })
                .reduce((grouped, f) => {

                    const key = f[this.significantAttribute];
                    grouped[key] = grouped[key] || [];
                    grouped[key].push(f);
                    return grouped;
                }, {});
            this.tableData = Object.keys(groupedBySignificantMember)
                .map((key: string) => {
                    return groupedBySignificantMember[key].reduce((prev, curr) => {
                        for (let i = 1; i <= this.dates.length; i++) {
                            prev['day' + i + 'Amount'] += curr['day' + i + 'Amount'];
                        }
                        return prev;
                    });
                });
        }
        this.initialized = true;
    }

    ngOnDestroy() {
        if (this.dataStreamDisposable) {
            this.dataStreamDisposable.unsubscribe();
        }
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}


